import { TimeSpan } from 'fitbeat.models';
import {
    IGymstateAnalyticsRow,
} from '../../entities';

export class GymstateAnalyticsManager {
    public getDateGymStateRows(
        givenDate: Date,
        gymstateAnalyticsRows: IGymstateAnalyticsRow[],
        gymTimeZone: string,
        ): IGymstateAnalyticsRow[] {
        const filteredList = gymstateAnalyticsRows.filter((singleRow: IGymstateAnalyticsRow) => {
            const isToday = TimeSpan.areOnSameDayInTimeZone(singleRow.startTime, givenDate, gymTimeZone);
            return isToday;
        });
        return filteredList;
    }
    public sortAndRemoveDuplicate(dataList: IGymstateAnalyticsRow[]) {
        const sortedList = dataList.sort((a: IGymstateAnalyticsRow, b: IGymstateAnalyticsRow) => {
          const firstItem = a.effortPoints || 0;
          const secondItem = b.effortPoints || 0;
          return secondItem - firstItem;
        });
        const noneDuplicateList: IGymstateAnalyticsRow[] = [];
        for (const singleItem of sortedList) {
          const singleItemIsDuplicate = noneDuplicateList.find(
            (item: IGymstateAnalyticsRow) => item.user.uid === singleItem.user.uid);

          if (!singleItemIsDuplicate && singleItem.effortPoints) {
            noneDuplicateList.push(singleItem);
          } else {
            if (singleItemIsDuplicate && singleItemIsDuplicate.effortPoints && singleItem.effortPoints) {
              noneDuplicateList[noneDuplicateList.indexOf(singleItemIsDuplicate)] =
                singleItemIsDuplicate.effortPoints < singleItem.effortPoints
                  ? singleItem
                  : singleItemIsDuplicate;
            }
          }
        }
        return noneDuplicateList;
    }

  public sumWeekWorkouts(dataList: IGymstateAnalyticsRow[]) {
    const workoutMap = new Map<string, IGymstateAnalyticsRow>();
    dataList.forEach((row: IGymstateAnalyticsRow) => {
      const singleRowForUser = workoutMap.get(row.user.uid);
      if (!singleRowForUser) {
        workoutMap.set(row.user.uid, row);
        return;
      }
      if (!singleRowForUser.effortPoints || !singleRowForUser.calories) {
        return;
      }
      singleRowForUser.effortPoints += row.effortPoints || 0;
      singleRowForUser.calories += row.calories || 0;
      workoutMap.set(row.user.uid, singleRowForUser);
    });
    const allRows = Array.from(workoutMap.values());
    return allRows.sort((a: IGymstateAnalyticsRow, b: IGymstateAnalyticsRow) => {
      return (b.effortPoints || 0) - (a.effortPoints || 0);
    });
  }
}
